"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Konva = void 0;
var _CoreInternals_1 = require("./_CoreInternals");
Object.defineProperty(exports, "Konva", { enumerable: true, get: function () { return _CoreInternals_1.Konva; } });
const _CoreInternals_2 = require("./_CoreInternals");
module.exports = _CoreInternals_2.Konva;
